import { render, staticRenderFns } from "./UpgradeBox.vue?vue&type=template&id=28290132&"
import script from "./UpgradeBox.vue?vue&type=script&lang=js&"
export * from "./UpgradeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureagent/_work/5/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28290132')) {
      api.createRecord('28290132', component.options)
    } else {
      api.reload('28290132', component.options)
    }
    module.hot.accept("./UpgradeBox.vue?vue&type=template&id=28290132&", function () {
      api.rerender('28290132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upgrade/UpgradeBox.vue"
export default component.exports